export enum PaperMarginType {
  NORMAL = 'normal',
  NARROW = 'narrow',
  MODERATE = 'moderate',
  WIDE = 'wide'
}

export const PaperMarginTypeTextMap = {
  [PaperMarginType.NORMAL]: '常规',
  [PaperMarginType.NARROW]: '窄',
  [PaperMarginType.MODERATE]: '适中',
  [PaperMarginType.WIDE]: '宽'
}

export const PaperMarginTypeValueMap = {
  [PaperMarginType.NORMAL]: {
    top: '2.54cm',
    right: '2.54cm',
    bottom: '2.54cm',
    left: '2.54cm'
  },
  [PaperMarginType.NARROW]: {
    top: '1.27cm',
    right: '1.27cm',
    bottom: '1.27cm',
    left: '1.27cm'
  },
  [PaperMarginType.MODERATE]: {
    top: '1.91cm',
    right: '1.91cm',
    bottom: '1.91cm',
    left: '1.91cm'
  },
  [PaperMarginType.WIDE]: {
    top: '3.17cm',
    right: '3.17cm',
    bottom: '3.17cm',
    left: '3.17cm'
  }
}
